import Grid from '@material-ui/core/Grid';
import TextField from '@mui/material/TextField';
import { Autocomplete } from '@mui/material';
import { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { Formik, useFormik, FormikProvider, Field } from 'formik';
import { Box, Button } from '@material-ui/core';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Checkbox from '@mui/material/Checkbox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { da } from 'date-fns/locale';
import Chip from '@mui/material/Chip';
import {DebounceInput} from 'react-debounce-input';
import { strReturnOnlyNumbersPositive } from './Sanger';
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import IconButton from '@mui/material/IconButton';
import RemoveCircle from '@mui/icons-material/RemoveCircle';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';



const uncheckedIcon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const CHIP_MAX_WIDTH =  100;
const CHIP_ICON_WIDTH = 30;

const EllipsisText = (props) => {
  const { children } = props

  return (
    <div style={{
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: CHIP_MAX_WIDTH - CHIP_ICON_WIDTH
      }}>
      {children}
    </div>
  )
}

const SangerRow = (props) => {
  const rowIndex = props.index;
  const data = props.data;
  const primers = props.primers;
  const formik = props.formik;
  const primerColors = props.primerColors;
  const primerMapToList = props.primerMapToList;
  const samplesLength = props.samplesLength;
  const reactCount = props.reactCount;
  const reactCountLimit = reactCount >= 96;
  const showAllErrors = props.showAllErrors;
  const submitShowError = props.submitShowError;

  const rowData = {
    id: data.id,
    sampleName: data.sampleName,
    primerRowList: data.primerRowList,
    premixed: data.premixed,
    concVal: data.concVal,
    readLen: data.readLen,
    vol: data.vol,
    type: data.type,
    template: data.template,
    key: data.key,
    touched: data.touched
  };
  

  const rowLengthX = Math.floor(rowIndex / 8);
  const rowLengthY = rowIndex % 8;
    var startX = rowLengthX + 1;
    let sX = startX.toString();
    let sY = String.fromCharCode(rowLengthY + 65);
  const well = sY + sX;

  const [selectedPrimers, setSelectedPrimers] = useState([])
  useEffect(() => {
    var selectedPrimersCopy = []
    rowData.primerRowList.forEach((key) => {
      if (primers.get(key) != undefined) {
        selectedPrimersCopy.push({
          key: key,
          primerName: primers.get(key).primerName
        })
      }
    })
    setSelectedPrimers(selectedPrimersCopy)
  }, [rowData.primerRowList.length])

  // var selectedPrimers = []
  // rowData.primerRowList.forEach((key) => {
  //   primerMapToList.forEach((primerItem) => {
  //     if (key == primerItem.key) {
  //       selectedPrimers.push(primerItem)
  //     }
  //   })
  // })

  const [templateOptions, setTemplateOptions] = useState([]);
  var typeOptions = ['DNA', 'Plasmid-insert', 'Plasmid']
  // var templateOptions = ['PCR Product: 100 - 200 bp', 'Plasmid - Single Strand', 'Plasmid - Double Strand']
  // var templateOptions = []

  const updateSample = props.updateSample;
  const removeSample = props.removeSample;
  const addNewSampleIndex = props.addNewSampleIndex;
  const updatePrimer = props.updatePrimer;

  const handleChange = (data, rowIndex) => {
    if (data.type != null) {
      if (data.type === "Plasmid" && (rowData.type === "DNA" || rowData.type === "Plasmid-insert")) {
        data.template = ''
      }
      if ((data.type === "DNA" || data.type === "Plasmid-insert") && (rowData.type === "Plasmid")) {
        data.template = ''
      } 
    }
    const tempData = { ...rowData, ...data };
    updateSample(tempData, rowIndex);
  };

  const handleChangePrimer = (data, rowIndex) => {
    const tempData = { ...rowData, ...data };
    updatePrimer(data, tempData);
  };

  const updateTemplateOptions = (type, options) => {
    if (type === 'DNA' || type === 'Plasmid-insert') {
      options = ['PCR Product: 100 - 200 bp', 'PCR Product: 200 - 500 bp', 'PCR Product: 500 - 1000 bp','PCR Product: 1000 - 2000 bp', 'PCR Product: >2000 bp']
    } else if (type === 'Plasmid') {
      options = ['Plasmid: Single Strand', 'Plasmid: Double Strand', 'Plasmid: Cosmid, BAC', 'Bacterial genomic DNA']
    }
    setTemplateOptions(options);
    return options;
  }

  return (
    <FormikProvider key={data.id[10]} value={formik}>
      <Grid key={data.id[11]} container style={{paddingRight: 10, paddingLeft: 10, marginTop: 0, paddingTop: 0, marginBottom: 0}}>
        <Grid item>
          {rowIndex == 0 ? (<Grid xs={12} style={{fontSize: 14, marginLeft: 10}}>
            Well
          </Grid>) : (<>
          </>)}
          <TextField
            id="well"
            variant="outlined"
            disabled={true}
            defaultValue={well}
            key={data.id[1]}
            sx={{ width: 45, '& .MuiInputBase-root': { height: 40, borderRadius: 0 },'& legend': { display: 'none' },
            '& fieldset': { top: 0 }, }}
          />
        </Grid>
        <Grid item key={data.id[12]}>
        {rowIndex == 0 ? (<Grid xs={12} style={{fontSize: 14, marginLeft: 10}}>
            Sample Name
          </Grid>) : (<>
          </>)}
          <Field name={`samples.${rowIndex}.sampleName`} key={data.id[13]}>
            {({ field, form: { touched, errors }, meta }) => (
              <DebounceInput
                debounceTimeout={500}
                minLength={1}
                key={data.id[2]}
                element={TextField}
                required
                id="sample-name"
                variant="outlined"
                sx={{ '& .MuiInputBase-root': { width: 140, height: 40, borderRadius: 0, borderColor: 'black' },'& legend': { display: 'none' },
                '& fieldset': { top: 0 }, "& .MuiInputBase-input": {
                  overflow: "hidden",
                  textOverflow: "ellipsis"
                }}}
                inputProps={{ spellCheck: false }}
                label={undefined}
                placeholder="Sample Name"
                value={rowData.sampleName}
                onBlur={(e) => {
                  var newTouched = rowData.touched;
                  newTouched[0] = true;
                  handleChange({ touched: newTouched }, rowIndex);
                }}
                onChange={(e) => {
                  var newTouched = rowData.touched;
                  newTouched[0] = true;
                  handleChange({ sampleName: e.target.value, touched: newTouched }, rowIndex);
                }}
                error={((rowData.touched[0] || submitShowError)) && meta.error}
              />)}
              </Field>
        </Grid>
        <Grid item key={data.id[14]}>
        {rowIndex == 0 ? (<Grid xs={12} style={{fontSize: 14, marginLeft: 10}}>
            Primers
          </Grid>) : (<>
          </>)}
          <Field name={`samples.${rowIndex}.primerRowList`} key={data.id[15]}>
            {({ field, form: { touched, errors }, meta }) => (
              <Autocomplete
              freeSolo
              multiple
              key={data.id[3]}
              // forcePopupIcon={true}
              // disablePortal={true}
              disableCloseOnSelect
              size="small"
              id="primerList"
              variant="outlined"
              options={primerMapToList}
              value={selectedPrimers}
              disabled={primerMapToList.length == 0 || rowData.premixed}
              onBlur={(e) => {
                var newTouched = rowData.touched;
                newTouched[1] = true;
                handleChange({ touched: newTouched }, rowIndex);
              }}
              // getOptionDisabled={option => option.primerName == ''}
              getOptionLabel={(option) => option.primerName}
              isOptionEqualToValue={(option, value) => option.key === value.key}
              getOptionDisabled={(option) => reactCountLimit && !rowData.primerRowList.includes(option.key)}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                      <Chip
                          style={{
                            backgroundColor: primerColors.get(option.key),
                            height: 22
                          }}
                          variant="outlined"
                          // label={<div style={{fontSize: 15}}>{primers.get(option.key) ? primers.get(option.key).primerName : ""}</div>}
                          label={<EllipsisText>{primers.get(option.key) ? primers.get(option.key).primerName : ""}</EllipsisText>}
                          {...getTagProps({ index })}
                      />
                  ))
              }
              onChange={async (e, data, reason, detail) => {
                if (reason === 'remove-option') {
                  console.log(detail.option);
                  console.log("DETAIL OPTION")
                };
                var newList = [];
                data.map((dataSelected, index) => {
                  if (typeof dataSelected === 'object') {
                    newList.push(dataSelected.key)
                  }
                })
                var newTouched = rowData.touched;
                newTouched[1] = true;
                handleChange({ primerRowList: newList, touched: newTouched }, rowIndex);
              }}
              renderOption={(props, option, { selected }) => (
                <li {...props}
                style={{
                  backgroundColor: primerColors.get(option.key)
                }}>
                  <Checkbox
                    icon={uncheckedIcon}
                    checkedIcon={checkedIcon}
                    style={{ marginLeft:-20, marginRight: -5 }}
                    checked={selected}
                  />
                  <div style={{flexWrap: 'wrap', wordWrap: 'break-word', width: 140}}>
                  {option.primerName}
                  </div>
                </li>
              )}
              sx={{ width: 170, '& .MuiInputBase-root': {minHeight: 40, borderRadius: 0}, '& legend': { display: 'none' },
              '& fieldset': { top: 0 }, }}
              renderInput={(params) => (
                // console.log(params),
                <TextField
                  {...params}
                  key={data.id[16]}
                  // label="Primers"
                  placeholder={rowData.premixed ? 'Sample is premixed' : 'Primers'}
                  error={((rowData.touched[1] || submitShowError)) && meta.error}
                  InputProps={{...params.InputProps,startAdornment: (
                    !rowData.premixed ? (
                    <>
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                      {params.InputProps.startAdornment}
                    </>) : (<>
                    </>)
                  )}}
                  
                />
              )}
            />)}
            </Field>
        </Grid>
        <Grid item key={data.id[17]}>
        {rowIndex == 0 ? (<Grid xs={12} style={{fontSize: 14, marginLeft: -10, marginRight: -10}}>
            Premix?
          </Grid>) : (<>
          </>)}
          <Checkbox
          key={data.id[4]}
            checked={rowData.premixed}
            style={{paddingBottom: 0}}
            onChange={(e) => {
              handleChange({ premixed: e.target.checked }, rowIndex);
            }}
            >
          </Checkbox>
        </Grid>
        <Grid item alignItems="stretch" key={data.id[18]}>
        {rowIndex == 0 ? (<Grid xs={12} style={{fontSize: 14, marginLeft: 10}}>
            Concentration
          </Grid>) : (<>
          </>)}
          <Field name={`samples.${rowIndex}.concVal`} key={data.id[19]}>
            {({ field, form: { touched, errors }, meta }) => (
              <DebounceInput
              key={data.id[5]}
              debounceTimeout={500}
              minLength={1}
              element={TextField}
                required
                id="conc"
                placeholder={"Conc"}
                variant="outlined"
                InputProps={{ inputmode: 'numeric', pattern: '[0-9]*', endAdornment: <InputAdornment style={{fontSize: 10, marginLeft: -10, marginRight: -10}} position="end">ng/µl</InputAdornment>}}
                value={rowData.concVal}
                sx={{ '& .MuiInputBase-root': { height: 40, borderRadius: 0, width: 110 }, '& legend': { display: 'none' },
                '& fieldset': { top: 0 }, }}
                error={((rowData.touched[2] || submitShowError)) && meta.error}
                onBlur={(e) => {
                  var newTouched = rowData.touched;
                  newTouched[2] = true;
                  handleChange({ touched: newTouched }, rowIndex);
                }}
                onChange={async (e) => {
                  var newTouched = rowData.touched;
                  newTouched[2] = true;
                  handleChange({ concVal: e.target.value, touched: newTouched }, rowIndex);
                }}
              />)}
              </Field>
        </Grid>
        <Grid item alignItems="stretch" key={data.id[20]}>
        {rowIndex == 0 ? (<Grid xs={12} style={{fontSize: 14, marginLeft: 0}}>
            Read Length
          </Grid>) : (<>
          </>)}
          <Field name={`samples.${rowIndex}.concVal`}>
            {({ field, form: { touched, errors }, meta }) => (
              <DebounceInput
              key={data.id[6]}
              debounceTimeout={500}
              minLength={1}
              element={TextField}
                required
                id="read-len"
                placeholder={"Read"}
                variant="outlined"
                InputProps={{ inputmode: 'numeric', pattern: '[0-9]*', endAdornment: <InputAdornment style={{size: 10, marginLeft: -10, marginRight: -10}} position="end">bp</InputAdornment>}}
                value={rowData.readLen}
                sx={{ '& .MuiInputBase-root': { height: 40, borderRadius: 0, width: 80 }, '& legend': { display: 'none' },
                '& fieldset': { top: 0 }, }}
                error={((rowData.touched[3] || submitShowError)) && meta.error}
                onBlur={(e) => {
                  var newTouched = rowData.touched;
                  newTouched[3] = true;
                  handleChange({ touched: newTouched }, rowIndex);
                }}
                onChange={async (e) => {
                  var newTouched = rowData.touched;
                  newTouched[3] = true;
                  handleChange({ readLen: e.target.value, touched: newTouched }, rowIndex);
                }}
              />)}
              </Field>
        </Grid>
        <Grid item>
        {rowIndex == 0 ? (<Grid xs={12} style={{fontSize: 14, marginLeft: 10}}>
            Volume
          </Grid>) : (<>
          </>)}
        <Grid item alignItems="stretch" style={{ display: 'flex', width: 65 }}>
        <Field name={`samples.${rowIndex}.vol`}>
            {({ field, form: { touched, errors }, meta }) => (
              <DebounceInput
              key={data.id[7]}
              debounceTimeout={500}
              minLength={1}
              element={TextField}
                id="vol"
                placeholder={"Vol"}
                variant="outlined"
                value={rowData.vol}
                // onClick={() => {
                //   formik.setFieldValue('vol', true);
                // }}
                sx={{ width: 300, '& .MuiInputBase-root': {height: 40, borderRadius: 0, width: 65}, '& legend': { display: 'none' },
                '& fieldset': { top: 0 }, }}
                error={((rowData.touched[4] || submitShowError)) && meta.error}
                InputProps={{ inputmode: 'numeric', pattern: '[0-9]*', endAdornment: <InputAdornment style={{size: 10, marginLeft: -11, marginRight: -10}} position="end">µl</InputAdornment>}}
                onBlur={(e) => {
                  var newTouched = rowData.touched;
                  newTouched[4] = true;
                  handleChange({ touched: newTouched }, rowIndex);
                }}
                onChange={async (e) => {
                  // var valInput = e.target.value !== undefined ? e.target.value : "0";
                  // var val = strReturnOnlyNumbersPositive(valInput);
                  var newTouched = rowData.touched;
                  newTouched[4] = true;
                  handleChange({ vol: e.target.value, touched: newTouched }, rowIndex);
                }}
              />)}
              </Field>
        </Grid>
        </Grid>
        <Grid>
        {rowIndex == 0 ? (<Grid xs={12} style={{fontSize: 14, marginLeft: 10}}>
            Type
          </Grid>) : (<>
          </>)}
        <Grid item alignItems="stretch" style={{ display: 'flex', width: 140 }}>
        <Field name={`samples.${rowIndex}.type`}>
            {({ field, form: { touched, errors }, meta }) => (
          <Autocomplete
            disablePortal
            key={data.id[8]}
            disableClearable={true}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            id="type"
            variant="outlined"
            options={typeOptions}
            value={rowData.type}
            onBlur={(e) => {
              var newTouched = rowData.touched;
              newTouched[5] = true;
              handleChange({ touched: newTouched }, rowIndex);
            }}
            onChange={async (e, data) => {
              var newTouched = rowData.touched;
              newTouched[5] = true;
              handleChange({ type: data, touched: newTouched }, rowIndex)
              updateTemplateOptions(data, templateOptions)
            }}
            sx={{ width: 150, '& .MuiInputBase-root': { height: 40, borderRadius: 0 }, '& legend': { display: 'none' },
            '& fieldset': { top: 0 }, }}
            renderInput={(params) => 
              <TextField 
                {...params} 
                placeholder="Type"
                inputProps={{
                  ...params.inputProps,
                  readOnly: true,
                  style : {marginTop: -5, marginLeft: -10}
                }}
                error={((rowData.touched[5] || submitShowError)) && meta.error}
              />}
          />)}
          </Field>
        </Grid>
        </Grid>
        <Grid>
        {rowIndex == 0 ? (<Grid xs={12} style={{fontSize: 14, marginLeft: 10}}>
            Desired Template
          </Grid>) : (<>
          </>)}
        <Grid item alignItems="stretch" style={{ display: 'flex', width: 180 }}>
        <Field name={`samples.${rowIndex}.concVal`}>
            {({ field, form: { touched, errors }, meta }) => (
          <Autocomplete
            key={data.id[9]}
            disablePortal
            disableClearable={true}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            id="template"
            variant="outlined"
            disabled={rowData.type === "" || rowData.type === undefined}
            options={templateOptions}
            value={rowData.template}
            onBlur={(e) => {
              var newTouched = rowData.touched;
              newTouched[6] = true;
              handleChange({ touched: newTouched }, rowIndex);
            }}
            onChange={ async (e, data) => {
              var newTouched = rowData.touched;
              newTouched[6] = true;
              handleChange({ template: data, touched: newTouched }, rowIndex)
            }}
            sx={{ width: 180, '& .MuiInputBase-root': { height: 40, borderRadius: 0 }, '& legend': { display: 'none' },
            '& fieldset': { top: 0 }, }}
            renderInput={(params) => (
              <TextField
                {...params} 
                placeholder="Desired Template"
                inputProps={{
                  ...params.inputProps,
                  readOnly: true,
                  shrink: false, 
                  notched: false,
                  style : {marginTop: -5, fontSize: 13, marginLeft: -10}
                }}
                error={((rowData.touched[6] || submitShowError)) && meta.error}
              />
            )}
            renderOption={(props, option, { selected }) => (
              <li {...props}
              style={{
                fontSize: 12,
                marginLeft: -12,
                marginRight: -12
              }}>
                {option}
              </li>
            )}
          />)}
          </Field>
        </Grid>
        </Grid>
        <Grid>
        {rowIndex == 0 ? (<Grid xs={12} style={{fontSize: 14, marginLeft: 3}}>
            <br></br>
          </Grid>) : (<>
          </>)}
        <IconButton onClick={() => addNewSampleIndex(rowIndex)}>
          <AddCircleIcon/>
        </IconButton>
        </Grid>
        <Grid>
        {rowIndex == 0 ? (<Grid xs={12} style={{fontSize: 14, marginLeft: 3}}>
            <br></br>
          </Grid>) : (<>
          </>)}
        <IconButton onClick={() => removeSample(rowIndex)}>
          <RemoveCircle/>
        </IconButton>
        </Grid>
        <Grid item xs={12} style={{marginTop: 0}}>
        <Field name={`samples.${rowIndex}`}>
            {({ field, form: { touched, errors }, meta }) => (
              meta.error != undefined ? (
              <ul style={{listStyleType: 'disc',
              // display: 'list-item',
              margin: 0,
              verticalAlign: 'middle',
              color: '#d8000c',
              backgroundColor: '#ffd2d2'}}>
                {(rowData.touched[0] || submitShowError) && showAllErrors ? (
                <li>
                {meta.error.sampleName ? <>● {meta.error.sampleName}</> : <></>}
              </li>
                ): (<>
                </>)}
                {(rowData.touched[1] || submitShowError) && showAllErrors ? (
                <li>
                {meta.error.primerRowList ? <>● {meta.error.primerRowList}</> : <></>}
              </li>
                ): (<>
                </>)}
                {(rowData.touched[2] || submitShowError) && showAllErrors ? (
                <li>
                {meta.error.concVal ? <>● {meta.error.concVal}</> : <></>}
              </li>
                ): (<>
                </>)}
                {(rowData.touched[3] || submitShowError) && showAllErrors ? (
                <li>
                {meta.error.readLen ? <>● {meta.error.readLen}</> : <></>}
              </li>
                ): (<>
                </>)}
                {(rowData.touched[4] || submitShowError) && showAllErrors ? (
                <li>
                {meta.error.vol ? <>● {meta.error.vol}</> : <></>}
              </li>
                ): (<>
                </>)}
                {(rowData.touched[5] || submitShowError) && showAllErrors ? (
                <li>
                {meta.error.type ? <>● {meta.error.type}</> : <></>}
              </li>
                ): (<>
                </>)}
                {(rowData.touched[6] || submitShowError) && showAllErrors ? (
                <li>
                {meta.error.template ? <>● {meta.error.template}</> : <></>}
              </li>
                ): (<>
                </>)}
              </ul>
              ) : (
                <>
                </>
              )
            )}
        </Field>
        </Grid>
      </Grid>
    </FormikProvider>
  );
};

export default SangerRow;
